import type { Coordinates } from '@/types/graphql/maps'
import type { Nullable } from '@/types/util'

export interface IssueLocationGeocodeArgs {
  /** Does the company's form configuration show the place field at all. */
  visible: boolean
  /** The place as typed/picked in the form. */
  placename: string
  /** Coordinates already resolved for that place, if any. */
  coordinates: Nullable<Coordinates>
}

/**
 * Whether submitting the issue has to ask Google to resolve the place.
 *
 * The place field is configurable per company. When it is optional and left
 * blank there is nothing to resolve — and asking Google to geocode an empty
 * address answers ZERO_RESULTS, which aborted the submit with "could not find
 * location" and made the issue impossible to create.
 */
export function needsLocationGeocode({
  visible,
  placename,
  coordinates,
}: IssueLocationGeocodeArgs): boolean {
  if (!visible) return false
  if (!placename.trim()) return false
  return coordinates.lat === null || coordinates.lng === null
}
